import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from '@mui/material/IconButton';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { NavLink } from "react-router-dom";
import UploadDialog from "./Dialogues/UploadDialog";
import ExportDataDialog from "./Dialogues/ExportDataDialog";
import swaasaLogo from "../Assets/images/Swaasa.png";
import apolloLogo from '../Assets/images/apollo.png'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import axios from '../axios';
import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";
import '../Assets/styles/newStyles/Navbar.css'
import { css } from "@emotion/react";
import PropTypes from 'prop-types';



const theme = createTheme({
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          "&:selected": {
            backgroundColor: "#ff7d00",
            color: "red",
            fontWeight: "bold"
          },
          "&:hover": {
            // backgroundColor: "#ffdcb7",
            // cursor: 'pointer'
          }
        }
      }
    }
  }
});


const useStyles = makeStyles({
  root: {
    // Your existing styles...
  },
  selected: {
    backgroundColor: "pink", // Change background color when selected
    color: "red",
    fontWeight: "bold"
  }
});

const BiggerListItemIcon = withStyles({
  root: {
    "& .MuiSvgIcon-root": { fontSize: "3rem" },
  },
})(ListItemIcon);

function Navbar({ onToggleCollapse }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [open, setOpen] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [highlightedItemIndex, setHighlightedItemIndex] = useState(0);
  const [drawerWidth, setDrawerWidth] = useState(window.innerWidth >= 768 ? 240 : 180);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(window.innerWidth >= 769 ? 240 : 180);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const storedIndex = localStorage.getItem("selectedItemIndex");
    if (storedIndex !== null) {
      setSelectedItemIndex(parseInt(storedIndex));
      setHighlightedItemIndex(parseInt(storedIndex));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedItemIndex", selectedItemIndex);
  }, [selectedItemIndex]);

  const styles = useStyles();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const collapseIcon = collapsed ? <KeyboardDoubleArrowRightIcon /> : <KeyboardDoubleArrowLeftIcon />;

  // collapseIcon,
  const icons = [
    <PersonIcon />,
    (localStorage.validation !== "true" || localStorage.longitudinal_study === "true") && <AnalyticsIcon />,
    <AssessmentIcon />,
    <CloudDownloadIcon />,
  ];


  const handleExport = () => {
    setOpenExport(true);
    console.log("export button clicked");
    setHighlightedItemIndex(5);
  };

  const handleCloseExport = () => {
    setOpenExport(false);
    setHighlightedItemIndex(selectedItemIndex);
  };

  const exportData = () => {
    axios
      .get(`/export-data/${localStorage.adminId}`, {
        headers: { accessToken: localStorage.accessToken },
        responseType: "blob",
      })
      .then((response) => {
        console.log(response);
        console.log(response.data)
        console.log(typeof(response.data),"yrthff7");
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const fileName = localStorage.doctorId + "-(" + date +').xlsx'
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      });
  };

  const exportApolloData = () => {
    axios
      .get(`/export-executive-data?doctorId=${localStorage.doctorId}`, {
        headers: { accessToken: localStorage.accessToken },
        responseType: "blob",
      })
      .then((response) => {
        console.log(response);
        console.log(response.data)
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const fileName = localStorage.doctorId + "-(" + date +').xlsx'
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      });
  };

  const handleUpload = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleListItemClick = (index) => {
    setSelectedItemIndex(index);
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
    // setDrawerWidth(collapsed ? window.innerWidth >= 769 ? 240 : 180 : 70);
    const width = collapsed ? (window.innerWidth >= 769 ? 240 : 180) : 70;
    setDrawerWidth(width);
    // localStorage.setItem("navbarWidth", `${width}px`);
    onToggleCollapse(!collapsed);
  };

  
  const drawer = (
    <ThemeProvider theme={theme}>
      <img className={localStorage.adminId === "admin@apollo.com" ? "apollo-logo-img": "nav-logo-img"} src={localStorage.adminId === "admin@apollo.com" ? apolloLogo : swaasaLogo} alt="logo" 
        style={{ width: collapsed ? '70px' : '', height: collapsed ? '20px' : '', margin: collapsed ? '20px 0 20px 10px' : '' }}
      />
      <Divider />
      {/* <div className="collapse-container" onClick={toggleCollapse}>
        {collapsed ? 
          <KeyboardDoubleArrowRightIcon sx={{color: "#ff7208"}} /> : <KeyboardDoubleArrowLeftIcon sx={{color: "#ff7208"}} />
        }
        {!collapsed ? 
          <p className="collapse-text">Collapse</p>
          :
          <p className="collapse-text">Expand</p>
        }
      </div> */}
      <List className={styles.root}>
        {[
          { text: "Patients", to: "/patients", tooltip: "View Patients" },
          (localStorage.validation !== "true" || localStorage.longitudinal_study == "true") && { text: "Analytics", to: "/analytics", tooltip: "View Analytics" },
          (localStorage.validation !== "true" || localStorage.longitudinal_study == "true") && { text: "Assessments", to: "/assessments", tooltip: "View Assessments" },
          (localStorage.export_data === "true" ) && { text: "Export", onClick: handleExport, tooltip: "Export Data" },
        ].map((item, index) => (
          item && (
            <ListItem key={item.text} onClick={() => handleListItemClick(index)} classes={{ selected: styles.selected }} 
              sx={{ backgroundColor: (index !== 3 && selectedItemIndex === index) ? "#ffdcb7" : "inherit", fontWeight: (index !== 3 && selectedItemIndex === index) ? "bold" : "normal" }}
              disablePadding
            >
              {item.to ? (
                <NavLink to={item.to} 
                  style={{ textDecoration: "none", color: "inherit" }} onClick={item.onClick ? () => item.onClick(index) : null} >
                  <ListItemButton >
                    <ListItemIcon sx={{ minWidth: '30px', borderRadius: '4px' }}>
                      <BiggerListItemIcon>{icons[index]}</BiggerListItemIcon>
                    </ListItemIcon>
                    {!collapsed && <ListItemText primary={item.text} />}
                  </ListItemButton>
                </NavLink>
              ) : (
                <ListItemButton onClick={item.onClick ? () => item.onClick(index) : null}>
                  <ListItemIcon>
                    <BiggerListItemIcon>{icons[index]}</BiggerListItemIcon>
                  </ListItemIcon>
                  {!collapsed && <ListItemText primary={item.text} />}
                </ListItemButton>
              )}
            </ListItem>
          )
        ))}
        {localStorage.bulkupload === "true" && (
          <ListItemButton onClick={handleUpload}>
            <ListItemIcon>
              <BiggerListItemIcon>
                <UploadFileIcon />
              </BiggerListItemIcon>
            </ListItemIcon>
            <ListItemText primary="Upload" />
          </ListItemButton>
        )}
      </List>
      {!collapsed &&(
        <div className="navbar-footer">
          <p className="powered-by">Powered by</p>
          <p className="swaasa-ai">Swaasa.AI</p>
          <p className="swaasa-version">
            Swaasa AI Platform {process.env.REACT_APP_SWAASA_VERSION}
          </p>
          <p className="swaasa-version">
            Dashboard {process.env.REACT_APP_VERSION}
          </p>
        </div>
      )}
    </ThemeProvider>
  );

  return (
    <div 
      // className="navbar"
    >
        <ThemeProvider theme={theme}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon sx={{ color: "orange", fontSize: 32, marginLeft: "20px" }} />
          <span style={{ marginLeft: "10px" }}>Menu</span>
        </IconButton>
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                fontSize: "2.5rem",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        <ExportDataDialog
          openExport={openExport}
          handleCloseExport = {(data) => handleCloseExport()}
          handleExport={exportData}
          handleExportApollo={exportApolloData}
        />
        <UploadDialog open={open}
          handleClose={(data) =>
          handleClose()
        } ></UploadDialog>
      </ThemeProvider>
    </div>
  );
}

Navbar.propTypes = {
  onToggleCollapse: PropTypes.func.isRequired,
};

export default Navbar;

